import { MissionDTO } from './MissionDTO';
import { Serializable } from './Serializable';

export class MyMissionsDTO extends Serializable {
    inProgress: number;
    finished: number;
    atRisk: number;
    missions: MissionDTO[];

    constructor() {
        super();
    }

}
